import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=4df62ff6&scoped=true"
import script from "./MessageText.vue?vue&type=script&lang=js"
export * from "./MessageText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df62ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df62ff6')) {
      api.createRecord('4df62ff6', component.options)
    } else {
      api.reload('4df62ff6', component.options)
    }
    module.hot.accept("./MessageText.vue?vue&type=template&id=4df62ff6&scoped=true", function () {
      api.rerender('4df62ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/Message/MessageText.vue"
export default component.exports